import { useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";
import { LOGO_URL, FTC_LOGO_URL, CONTACT_EMAIL, NAV_LINKS, scrollToSection } from "../lib/constants";
import { useI18n } from "../context/I18nContext";

const KEY_MAP = {
  Collections: "nav.collections", Automotive: "nav.automotive", Aviation: "nav.aviation",
  Yachting: "nav.yachting", "Real Estate": "nav.realEstate", Sold: "nav.sold",
  Bespoke: "nav.bespoke", Fees: "nav.fees", About: "nav.about", Contact: "nav.contact",
};

export const Footer = () => {
  const navigate = useNavigate();
  const { t } = useI18n();
  return (
    <footer data-testid="footer" className="bg-navy-900 border-t border-white/10 pt-20 pb-10 px-6 lg:px-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-12 gap-12 py-16 border-b border-white/10">
          <div className="md:col-span-5">
            <img src={LOGO_URL} alt="Royce International" className="h-24 w-auto object-contain mb-6" />
            <p className="font-sans text-white/40 text-sm max-w-sm leading-relaxed">{t("footer.desc")}</p>
            <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="inline-flex items-center gap-2 mt-6 font-sans text-gold text-sm hover:text-gold-light transition-colors">
              <Mail className="w-4 h-4" /> {CONTACT_EMAIL}
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="font-sans text-gold text-[10px] tracking-luxury uppercase mb-5">{t("footer.nav")}</p>
            <div className="grid grid-cols-2 gap-3">
              {NAV_LINKS.map((l) => (
                <button key={l.label} onClick={() => (l.path ? navigate(l.path) : scrollToSection(l.target))} className="text-left font-sans text-white/50 text-sm hover:text-gold transition-colors">
                  {t(KEY_MAP[l.label] || l.label)}
                </button>
              ))}
              <button onClick={() => navigate("/private-access")} className="text-left font-sans text-white/50 text-sm hover:text-gold transition-colors">
                {t("nav.privateAccess")}
              </button>
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="font-sans text-gold text-[10px] tracking-luxury uppercase mb-5">{t("footer.partner")}</p>
            <div className="glass rounded-xl p-6 flex items-center justify-center">
              <a
                href="https://www.frenchtouchconcierge.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-ftc-link"
                className="block transition-opacity duration-300 hover:opacity-80"
              >
                <img src={FTC_LOGO_URL} alt="French Touch Concierge" className="h-20 w-auto object-contain" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-sans text-white/30 text-xs">© {new Date().getFullYear()} Royce International. {t("footer.rights")}</p>
          <div className="flex gap-6">
            <a href="#" onClick={(e) => e.preventDefault()} className="font-sans text-white/30 text-xs hover:text-gold transition-colors">{t("footer.legal")}</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="font-sans text-white/30 text-xs hover:text-gold transition-colors">{t("footer.privacy")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
